import { render } from "./zhongyi-news.vue?vue&type=template&id=7527c81f&scoped=true"
import script from "./zhongyi-news.vue?vue&type=script&lang=js"
export * from "./zhongyi-news.vue?vue&type=script&lang=js"

import "./zhongyi-news.vue?vue&type=style&index=0&id=7527c81f&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7527c81f"]])

export default __exports__